module.exports = "<div class=\"subcontract-project-view\">\n  <shared-project-view project=\"$ctrl.project\"></shared-project-view>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/pages/admin/project-details/views/subcontract-project-view/subcontract-project-view.html
// module id = 958
// module chunks = 0